/**
 * Revision History
 * Data Model for WH Company List
 * 
 * 02/25/2022       hykim       Create
 */
import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class WhCustListItem extends SearchModelBase {
    type: string = '';
    companyId: string = '';
    name: string = '';
    address: string = '';
    city: string = '';
    state: string = '';
    zip: string = '';
    phone: string = '';
    fax: string = '';
    id: number = 0;
    void: boolean = false;
    attention: string = '';
    billGroup: string = '';
    boxRate: number = 0;
    fromBoxRate: number|null = null;
    toBoxRate: number|null = null;
    pcsRate: number = 0;
    fromPcsRate: number|null = null;
    toPcsRate: number|null = null;
    cftRate: number = 0;
    fromCftRate: number|null = null;
    toCftRate: number|null = null;
    boxCharge: number = 0;
    fromBoxCharge: number|null = null;
    toBoxCharge: number|null = null;
    labelCharge: number = 0;
    fromLabelCharge: number|null = null;
    toLabelCharge: number|null = null;
    docCharge: number = 0;
    fromDocCharge: number|null = null;
    toDocCharge: number|null = null;
    u1Date: string | null = null;
    formU1Date: string | null = null;
    toU1Date: string | null = null;
    u2Date: string | null = null;
    formU2Date: string | null = null;
    toU2Date: string | null = null;
    u2Id: string = '';
    u1Id: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Inactive', width: 60, dataIndex: 'void', type: XCol.XCellType.StrBool, align: XCol.XAlignType.Center, hiddenInColumnSetup: true, noNullOrEmptySearch: true}),
        XCol.Create({ col: 2, text: 'Type', width: 60, dataIndex: 'type'}),
        XCol.Create({ col: 3, text: 'Customer ID', width: 80, dataIndex: 'companyId', defaultColumnFocus : true}),
        XCol.Create({ col: 4, text: 'Customer Name', width: 200, dataIndex: 'name'}),
        XCol.Create({ col: 5, text: 'Phone', width: 80, dataIndex: 'phone'}),
        XCol.Create({ col: 6, text: 'Fax', width: 80, dataIndex: 'fax'}),
        XCol.Create({ col: 7, text: 'Attention', width: 100, dataIndex: 'attention'}),
        XCol.Create({ col: 8, text: 'Bill Group', width: 60, dataIndex: 'billGroup'}),
        XCol.Create({ col: 9, text: 'Box Rate', width: 80, dataIndex: 'boxRate', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, noNullOrEmptySearch: true }),
        XCol.Create({ col: 10, text: 'Pcs Rate', width: 80, dataIndex: 'pcsRate', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, noNullOrEmptySearch: true }),
        XCol.Create({ col: 11, text: 'CFT Rate', width: 80, dataIndex: 'cftRate', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, noNullOrEmptySearch: true }),
        XCol.Create({ col: 12, text: 'Box Charge', width: 80, dataIndex: 'boxCharge', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, noNullOrEmptySearch: true }),
        XCol.Create({ col: 13, text: 'Label Charge', width: 80, dataIndex: 'labelCharge', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, noNullOrEmptySearch: true }),
        XCol.Create({ col: 14, text: 'Doc Charge', width: 80, dataIndex: 'docCharge', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, noNullOrEmptySearch: true }),
        XCol.Create({ col: 15, text: 'Create Date', width: 100, dataIndex: 'u1Date', type: XCol.XCellType.DateTime}),
        XCol.Create({ col: 16, text: 'Create by', width: 80, dataIndex: 'u1Id'}),
        XCol.Create({ col: 17, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime}),
        XCol.Create({ col: 18, text: 'Update by', width: 80, dataIndex: 'u2Id'}),
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    //public static OrderBy = { orderBy: WhCustListItem.prototype.u2Date, orderByAscending: false };

    public static formatData(data: WhCustListItem[]) {
        return data.map((d: WhCustListItem) => ({
          ...d,
        }));
    }
    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        boxRate: {from: 'fromBoxRate', to: 'toBoxRate'},
        pcsRate: {from: 'fromPcsRate', to: 'toPcsRate'},
        cftRate: {from: 'fromCftRate', to: 'toCftRate'},
        boxCharge: {from: 'fromBoxCharge', to: 'toBoxCharge'},
        labelCharge: {from: 'fromLabelCharge', to: 'toLabelCharge'},
        docCharge: {from: 'fromDocCharge', to: 'toDocCharge'},
        u1Date: {from: 'fromU1Date', to: 'toU1Date'},
        u2Date: {from: 'fromU2Date', to: 'toU2Date'},
    }
}
